import { render } from "./ComponentListDocuments.vue?vue&type=template&id=517dc236&scoped=true"
import script from "./ComponentListDocuments.vue?vue&type=script&lang=js"
export * from "./ComponentListDocuments.vue?vue&type=script&lang=js"

import "./ComponentListDocuments.vue?vue&type=style&index=0&id=517dc236&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517dc236"]])

export default __exports__